import React from 'react';
import { FaSignInAlt } from 'react-icons/fa';
import platformUseImage from '../images/utilizando-plataforma.jpg';
import './ImageCtaSection.css';

const ImageCtaSection = ({ onOpenPlatformModal }) => {
  const openPlatform = () => {
    if (onOpenPlatformModal) {
      onOpenPlatformModal();
    }
  };

  return (
    <section className="image-cta-section">
      <div className="image-cta-container">
        <div className="image-cta-picture">
          <img src={platformUseImage} alt="Funcionários da empresa utilizando a plataforma de rastreamento" />
          <div className="image-cta-overlay" />
        </div>
        <div className="image-cta-content">
          <h2 className="image-cta-title">Sua frota sob controle, em um clique</h2>
          <p className="image-cta-subtitle">Visualize rotas, receba alertas e tome decisões rápidas com dados em tempo real. Experimente a plataforma agora e sinta a diferença na segurança e eficiência.</p>
          <button className="image-cta-button" onClick={openPlatform}>
            <FaSignInAlt /> Entrar na Plataforma
          </button>
        </div>
      </div>
    </section>
  );
};

export default ImageCtaSection;


